import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { xmlToJson } from '../util/xmlUtils';
import { actions as assetActions } from '../actions/asset';
import LoadingIndicator from '../components/LoadingIndicator';
import AppSettings from '../settings';
import { Container } from '../styled-components/Layout';

const serverPath = AppSettings.serverPath;

const $ = window.$;

const CompositorContainer = styled(Container) `
  background-color: #F0F0F0;
  border: 2px solid #5379A2;
  flex-direction: row;
  height: 100%;
`;

const ContentContainer = styled.iframe`
  border: none;
  height: 100%;
  overflow: hidden;
  width: 100%;
`;

class BuildGraphicLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      compositorWindow: null,
      compositorDomain: null,
      isLoading: true
    };
    this.assembleCallback = event => this.handleCompositorMessage(event);
  }

  UNSAFE_componentWillMount() {
    window.addEventListener('message', this.assembleCallback);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.assembleCallback);
  }

  getCompositorUrl() {
    if (this.props.visible) {
      const url = `${serverPath}compositor.aspx?autoload=true&userid=${this.props.userId}&contextid=${
        this.props.contextId
      }&replaceableimageid=${this.props.replaceableImageId}`;
      return url;
    }
    return '';
  }

  handleCompositorMessage(event) {
    if (!event.data && typeof event.data !== 'string') {
      return;
    }

    const parsedMessage = xmlToJson(event.data);
    if (!parsedMessage || !parsedMessage.message || !parsedMessage.message.$) {
      return;
    }

    switch (parsedMessage.message.$.type) {
      case 'assemblecomposite': {
        this.state.compositorWindow = event.source;
        this.state.compositorDomain = event.origin;
        this.handleAssembleComposite(parsedMessage);
        break;
      }
      case 'loaded': {
        this.setState({ isLoading: false });
        break;
      }
      case 'startcomposite': {
        this.setState({ isLoading: true });
        break;
      }
      default: {
        this.setState({ isLoading: false });
        break;
      }
    }
  }

  handleAssembleComposite(assembleMessage) {
    const imageDataURL = assembleMessage.message.imageData[0];
    const imageTitle = assembleMessage.message.title[0];
    const imageKeywords = assembleMessage.message.keywords[0];
    const assetCategoryId = assembleMessage.message.assetcategoryid[0];
    const that = this;

    $.ajax({
      type: 'POST',
      url: `${serverPath}/CompositorAssetHandler.ashx`,
      dataType: 'text',
      data: {
        requestId: '2',
        contextId: this.props.contextId,
        assetCategoryId,
        encodedImage: encodeURIComponent(imageDataURL),
        title: imageTitle,
        keywords: imageKeywords,
        username: this.props.username
      },
      success(response) {
        that.handleAssembleSuccess(response);
      },
      error(xhr, status, err) {
        console.log(`Error saving compositor image ${err}`);
        this.setState({ isLoading: false });
      }
    });
  }

  handleAssembleSuccess(response) {
    const compositeInfo = JSON.parse(response);
    this.reInitializeCompositor();
    this.props.updateSelectedReplaceable(compositeInfo.assetId, compositeInfo.url);
    this.props.onAssembleComplete();
    this.setState({ isLoading: false });
  }

  reInitializeCompositor() {
    const destinationWindow = this.state.compositorWindow;
    const url = window.location;

    const message =
      `<message type='initializecompositor'><url>${url}</url>` +
      '<templateid>2086F19B-E993-499C-A68E-6C466CB09E19</templateid>' +
      `<replaceableimageid>${this.props.replaceableImageId}</replaceableimageid></message>`;

    destinationWindow.postMessage(message, this.state.compositorDomain);
  }

  render() {
    return (
      <CompositorContainer>
        <LoadingIndicator visible={this.state.isLoading} />
        <ContentContainer scrolling="no" src={this.getCompositorUrl()} />
      </CompositorContainer>
    );
  }
}

const mapStateToProps = state => ({
  contextId: state.content.contextId,
  userId: state.auth.user.userId,
  username: state.auth.user.username,
  replaceableImageId: state.assets.selectedReplaceableId
});

const mapActionCreators = {
  updateSelectedReplaceable: assetActions.updateSelectedReplaceable
};

BuildGraphicLayout.defaultProps = {
  contextId: 1,
  userId: '-1',
  username: '-1',
  replaceableImageId: '-1',
  onAssembleComplete: () => {}
};

BuildGraphicLayout.propTypes = {
  contextId: PropTypes.number.isRequired,
  userId: PropTypes.number.isRequired,
  username: PropTypes.string,
  replaceableImageId: PropTypes.string.isRequired,
  visible: PropTypes.bool.isRequired,
  onAssembleComplete: PropTypes.func.isRequired,
  updateSelectedReplaceable: PropTypes.func.isRequired
};

export default connect(mapStateToProps, mapActionCreators)(BuildGraphicLayout);



// WEBPACK FOOTER //
// ./app/layouts/BuildGraphicLayout.js